/**
 * WMO weather interpretation codes.
 *
 * Open-Meteo reports conditions as WMO codes, which are precise but useless on
 * a wall panel — nobody reads "code 63". The condition group drives the icon,
 * the label is what a person actually reads.
 */
export const weatherConditions = [
    'clear',
    'partly',
    'cloudy',
    'fog',
    'drizzle',
    'rain',
    'showers',
    'snow',
    'thunder',
];
const WMO = {
    0: { condition: 'clear', label: 'Klar' },
    1: { condition: 'partly', label: 'Überwiegend klar' },
    2: { condition: 'partly', label: 'Teils bewölkt' },
    3: { condition: 'cloudy', label: 'Bedeckt' },
    45: { condition: 'fog', label: 'Nebel' },
    48: { condition: 'fog', label: 'Reifnebel' },
    51: { condition: 'drizzle', label: 'Leichter Nieselregen' },
    53: { condition: 'drizzle', label: 'Nieselregen' },
    55: { condition: 'drizzle', label: 'Starker Nieselregen' },
    56: { condition: 'drizzle', label: 'Gefrierender Nieselregen' },
    57: { condition: 'drizzle', label: 'Gefrierender Nieselregen' },
    61: { condition: 'rain', label: 'Leichter Regen' },
    63: { condition: 'rain', label: 'Regen' },
    65: { condition: 'rain', label: 'Starker Regen' },
    66: { condition: 'rain', label: 'Gefrierender Regen' },
    67: { condition: 'rain', label: 'Gefrierender Regen' },
    71: { condition: 'snow', label: 'Leichter Schneefall' },
    73: { condition: 'snow', label: 'Schneefall' },
    75: { condition: 'snow', label: 'Starker Schneefall' },
    77: { condition: 'snow', label: 'Schneegriesel' },
    80: { condition: 'showers', label: 'Leichte Schauer' },
    81: { condition: 'showers', label: 'Schauer' },
    82: { condition: 'showers', label: 'Kräftige Schauer' },
    85: { condition: 'snow', label: 'Leichte Schneeschauer' },
    86: { condition: 'snow', label: 'Schneeschauer' },
    95: { condition: 'thunder', label: 'Gewitter' },
    96: { condition: 'thunder', label: 'Gewitter mit Hagel' },
    99: { condition: 'thunder', label: 'Schweres Gewitter mit Hagel' },
};
/** Unknown codes degrade to "bewölkt" rather than throwing — a forecast is not worth a 500. */
export function describeWmo(code) {
    return WMO[code] ?? { condition: 'cloudy', label: 'Wechselhaft' };
}
/** Codes that mean water is falling out of the sky, for the outlook sentence. */
export function isWet(code) {
    const { condition } = describeWmo(code);
    return condition === 'drizzle' || condition === 'rain' || condition === 'showers' ||
        condition === 'snow' || condition === 'thunder';
}
